import { HttpHandlerFn, HttpInterceptorFn, HttpRequest } from '@angular/common/http';

export const encodingInterceptor: HttpInterceptorFn = (req: HttpRequest<unknown>, next: HttpHandlerFn) => {
  // Only intercept POST, PUT, PATCH methods with a body
  if ((req.method === 'POST' || req.method === 'PUT' || req.method === 'PATCH') && req.body) {
    const bodyType = detectBodyType(req.body);

    if (bodyType === 'json') {
      const encodedBody = base64Encode(JSON.stringify(req.body)); // Base64 encode the body
      const clonedRequest = req.clone({
        body: encodedBody,
        setHeaders: {
          'X-Body-Encoding': 'base64', // Indicate the encoding type
          'Content-Type': 'application/json', // Specify the content type for JSON
        },
      });
      return next(clonedRequest); // Forward the modified request
    }
  }

  return next(req); // Proceed without modification for other methods
};

// Detect if the body is JSON-like (text-based) or binary-like
function detectBodyType(body: unknown): 'json' | 'binary' {
  if (body instanceof FormData) {
    return 'binary'; // Skip encoding for file uploads
  }
  if (typeof body === 'string' || isPlainObject(body) || Array.isArray(body)) {
    return 'json';
  }
  return 'binary';
}

// Check if the object is a plain JS object (not a class instance)
function isPlainObject(obj: unknown): boolean {
  return Object.prototype.toString.call(obj) === '[object Object]' && Object.getPrototypeOf(obj) === Object.prototype;
}

// Base64 encode with proper UTF-8 handling
function base64Encode(str: string): string {
  return btoa(unescape(encodeURIComponent(str)));
}
